function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.8548 11.4233C19.8798 9.01709 15.6983 6.20898 11.1347 6.20898C6.55467 6.20898 2.37304 9.03617 0.414549 11.4233C0.221192 11.659 0.221192 11.9984 0.414549 12.2341C2.4364 14.6986 6.62765 17.4485 11.1347 17.4485C15.8019 17.4485 19.9655 14.5359 21.8548 12.2341C22.0482 11.9984 22.0482 11.659 21.8548 11.4233ZM15.4762 11.8287C15.4762 14.2226 13.5286 16.1703 11.1346 16.1703C8.74064 16.1703 6.7931 14.2225 6.7931 11.8287C6.7931 9.43482 8.74069 7.48719 11.1346 7.48719C13.5288 7.48723 15.4762 9.43507 15.4762 11.8287ZM1.77201 11.8289C2.49136 11.0812 4.22586 9.46771 6.66072 8.43212C5.1327 10.4399 5.1321 13.2159 6.65999 15.2244C4.8087 14.4398 3.08895 13.2001 1.77201 11.8289ZM15.6086 15.2253C17.1367 13.2175 17.1372 10.4416 15.6094 8.43305C17.4606 9.21769 19.1804 10.4574 20.4974 11.8285C19.778 12.5762 18.0435 14.1897 15.6086 15.2253Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.96094 11.8288C8.96094 13.027 9.93573 14.0018 11.134 14.0018C12.3322 14.0018 13.307 13.027 13.307 11.8288C13.307 10.6306 12.3322 9.65576 11.134 9.65576C9.93573 9.65576 8.96094 10.6306 8.96094 11.8288ZM12.0287 11.8288C12.0287 12.3222 11.6273 12.7236 11.134 12.7236C10.6406 12.7236 10.2392 12.3222 10.2392 11.8288C10.2392 11.3354 10.6406 10.934 11.134 10.934C11.6273 10.934 12.0287 11.3354 12.0287 11.8288Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1333 3.73292C11.4862 3.73292 11.7724 3.44676 11.7724 3.0938V1.6025C11.7724 1.24954 11.4862 0.963379 11.1333 0.963379C10.7803 0.963379 10.4941 1.24954 10.4941 1.6025V3.0938C10.4941 3.44676 10.7803 3.73292 11.1333 3.73292Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.9476 4.58758C15.254 4.76236 15.6444 4.6558 15.8194 4.34902L16.6699 2.85773C16.8448 2.55112 16.7381 2.16083 16.4314 1.98592C16.1247 1.81106 15.7345 1.91779 15.5596 2.22448L14.7091 3.71578C14.5342 4.02234 14.641 4.41268 14.9476 4.58758Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M6.45023 4.34901C6.62509 4.65562 7.01539 4.7624 7.32204 4.58753C7.62865 4.41267 7.73542 4.02234 7.56056 3.71573L6.71001 2.22443C6.53515 1.91782 6.14477 1.81105 5.8382 1.98591C5.53159 2.16078 5.42482 2.55111 5.59968 2.85772L6.45023 4.34901Z",
  fill: "currentColor"
});

function SvgReveals(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReveals);
export default __webpack_public_path__ + "static/media/reveals.68929b9b.svg";
export { ForwardRef as ReactComponent };